import * as Yup from 'yup';
import i18n from 'i18n';
import { VersionFieldEnum } from 'Data/interfaces/Nomenclatura/INomenclatureData';

export const createSchema = (
  versionFields: any[],
  hasNomenclatureControl?: boolean,
  stages?: string[],
) => {
  const fields: any = {};

  if (hasNomenclatureControl) {
    versionFields?.forEach((field) => {
      let validation = Yup.string().required(() => i18n.t('common:validation.fieldRequired'));

      if (field.CampoVersaoId === VersionFieldEnum.Revisao) {
        validation = validation.matches(/\d+/g, () => i18n.t('listagemArquivos:fileInfo.errorNoNumber'));
      }

      if (stages && field.CampoVersaoId === VersionFieldEnum.Fase) {
        validation = validation.oneOf(stages, ' ');
      }

      fields[`field${field.Ordem}`] = validation;
    });
  }
  else {
    fields['simpleFileName'] = Yup.string().required(() => i18n.t('common:validation.fieldRequired'));
  }

  return Yup.object().shape(fields);
};
